// 个人资料设置

import { httpRequest } from '@/utils/umiRequest';

interface PersonalInfoParams {
  name: string;
  en_name: string;
  signature: string;
}

// 获取个人资料设置
export async function getPersonalInfo(options?: Record<string, any>) {
  return httpRequest.get('/users/profile', {}, options);
}
// 修改个人资料设置
export async function updatePersonalInfo(data: PersonalInfoParams, options?: Record<string, any>) {
  return httpRequest.post('/users/update-profile', data, options);
}

// 修改密码
export async function updatePassword(data: any, options?: Record<string, any>) {
  return httpRequest.put('/users/password/update', data, options);
}
